import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const RequestFeedback = withAsync({
	loader: lazyForPaint(() => import(/* webpackChunkName: "request-feedback" */ './hocs')),
});
